<sb-searchable-list-section
	[persuadeCards]="packageEventItems()"
	[title]="title()"
	[useStoryblokCards]="false"
/>
